<template>
  <div class="container p-3 pb-4 margin-3 font-default-color">
    <div class="col-md-12 text-center" >
      <img class="mt-md-3 logo-size"
           src="../assets/logo-login.png">
      <p class="text-head">
        ระบบกรอกข้อมูลชันสูตรพลิกศพ
      </p>
    </div>
    <div class="row col-md-12" style="padding: 10px 0;border-top: 1px solid #2DA1A9;margin-left: 0">
      <div class="col-lg-6 col-md-10 col-sm-12 regis-form text-center">
        <div class="font-default-color font22">คำร้องลืมรหัสผ่าน</div>
        <!--                            <input type="text" class="custom-input-regis" placeholder="รหัสโรงพยาบาล" v-model="hospcode">-->
        <div class="d-block text-center col-10">
          <multiselect class="multiselect-style2"
                       v-model="valueHospital"
                       :options="optionHospital"
                       label="name"
                       select-label=""
                       selectedLabel=""
                       deselect-label=""
                       placeholder="เลือกโรงพยาบาล"
                       track-by="name"

          />
        </div>
        <select v-model="usertype_id"
                class="custom-input-regis font-default-color"
                type="text"
        >
          <option value="" disabled hidden>ประเภทผู้ใช้</option>
          <option value="1">โรงพยาบาล</option>
          <option value="2">จังหวัด</option>
          <option value="3">เขตสุขภาพ</option>
          <option value="4">ส่วนกลาง</option>
        </select>
        <!--                            <input type="text" class="custom-input-regis" placeholder="ประเภทผู้ใช้" v-model="usertype_id">-->
        <b-form @keyup.enter="checkValue">
          <span v-if="this.usertype_id ==2">
                            <div class="d-block text-center col-10">
                                <multiselect  class="multiselect-style2"
                                              :options="optionProvince"
                                              id="location_province_id"
                                              label="name"
                                              select-label=""
                                              selectedLabel=""
                                              deselect-label=""
                                              placeholder="เลือกจังหวัด"
                                              track-by="name"
                                              v-model="detailUser"
                                              style="font-size: 14px;background-color: transparent;"
                                              required/>
                            </div>
                           </span>
          <span v-if="this.usertype_id ==3">
               <select v-model="detailUser"
                       class="custom-input-regis font-default-color"
                       type="text"
               >
                <option value="" disabled hidden>เขตสุขภาพ</option>
                <option value="1">เขตสุขภาพที่ 1</option>
                <option value="2">เขตสุขภาพที่ 2</option>
                <option value="3">เขตสุขภาพที่ 3</option>
                <option value="4">เขตสุขภาพที่ 4</option>
                <option value="5">เขตสุขภาพที่ 5</option>
                <option value="6">เขตสุขภาพที่ 6</option>
                <option value="7">เขตสุขภาพที่ 7</option>
                <option value="8">เขตสุขภาพที่ 8</option>
                <option value="9">เขตสุขภาพที่ 9</option>
                <option value="10">เขตสุขภาพที่ 10</option>
                <option value="11">เขตสุขภาพที่ 11</option>
                <option value="12">เขตสุขภาพที่ 12</option>
                <option value="13">เขตสุขภาพที่ 13</option>
              </select>
             </span>
          <span v-if="this.usertype_id ==4">
            <input type="text" class="custom-input-regis" placeholder="สังกัด*" v-model="detailUser" required>
          </span>
          <input type="text" class="custom-input-regis" placeholder="ชื่อ*" v-model="first_name" required>
          <br v-if="msg.first_name"><span style="color: red;font-size: 12px" v-if="msg.first_name">{{msg.first_name}}</span><br v-if="msg.first_name">
          <input type="text" class="custom-input-regis" placeholder="นามสกุล*" v-model="last_name" required>
          <br v-if="msg.last_name"><span style="color: red;font-size: 12px" v-if="msg.last_name">{{msg.last_name}}</span><br v-if="msg.last_name">
          <input type="text" class="custom-input-regis" placeholder="อีเมล*" v-model="email" required>
          <br v-if="msg.email"><span style="color: red;font-size: 12px" v-if="msg.email">{{msg.email}}</span><br v-if="msg.email">
          <input type="text" class="custom-input-regis" @input="phone_number = phone_number.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                 placeholder="เบอร์โทรศัพท์*" maxlength="10" v-model="phone_number">
          <br v-if="msg.phone_number"><span style="color: red;font-size: 12px" v-if="msg.phone_number">{{msg.phone_number}}</span><br v-if="msg.phone_number">
          <input type="text" class="custom-input-regis" placeholder="เลข ว. หรือเลขบัตรพนักงาน" maxlength="5" v-model="staff_id" >
        </b-form>
        <div style="padding-top: 10px">
          <b-button @click="goToHomePage" style="margin: 0 1.5em 2em 0" size="sm"  variant="light"  class="font16 btn-register font-default-color">
            หน้าหลัก
          </b-button>
          <b-button @click="checkValue" style="margin: 0 0 2em 0;font-size: 16px" size="sm"  variant="light"  class="font16 btn-login ">
            ส่งคำขอ
          </b-button>
        </div>
      </div>
    </div>
    <!--            <pre class="alert-danger">{{optionHospital}}</pre>-->
  </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from 'vue-multiselect';
import swal from 'sweetalert2/dist/sweetalert2.min.css'
import Service from "../service";
import Swal from "sweetalert2";
export default {
  name: "LoginView",
  props: {
    id: {default: null}
  },
  components: {
    Multiselect
  },
  created() {
    this.$store.dispatch("Common/setProvince");
    // this.checkLogin();
    Service.Hospital.getHospital()
        .then(data=>{
          this.optionHospital = data;
        })
    // this.optionHospital = list_hospitals;
  },
  computed: {
    ...mapState({
      form: state => {
        return state.Auth.form;
      },
      optionProvince: state => {
        return state.Common.provinces;
      },
      optionDistrict: state => {
        return state.Common.districts;
      },
      login_form: state => {
        return state.Auth.login_form;
      },
      user_login: state => {
        return state.Auth.user_login
      },
      access_token: state => state.Auth.access_token,
    })
  },
  data() {
    return {
      optionHospital:[],
      first_name: "",
      last_name: "",
      staff_id: "",
      detailUser:"",
      usertype_id : "",
      sid : "",
      phone_number: "",
      email: "",
      passwords: "",
      hospcodes: "",
      password: "",
      hospcode: "",
      valueHospital:"",
      vip_password: "",
      password_confirmation: "",
      vip_password_confirmation: "",
      msg: [],
      dataObj:null
    };
  },
  watch: {
    email(value){
      // binding this to the data value in the email input
      this.email = value;
      this.validateEmail(value);
    },
    first_name(value){
      this.first_name = value;
      this.validateFirstName(value);
    },
    last_name(value){
      this.last_name = value;
      this.validateLastName(value);
    },
    staff_id(value){
      this.staff_id = value;
      this.validateDoctorID(value);
    },
    password(value){
      this.password = value;
      this.validatePassword(value);
    },
    phone_number(value){
      this.phone_number = value;
      this.validatePhonenumber(value);
    },
    vip_password(value){
      this.vip_password = value;
      this.validateVIPPassword(value);
    },
    password_confirmation(value){
      this.password_confirmation = value;
      this.validatePasswordconfirmation(value);
    },
    vip_password_confirmation(value){
      this.vip_password_confirmation = value;
      this.validateVIPPasswordconfirmation(value);
    },
  },
  methods: {
    validateEmail(value){
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value.trim()))
      {
        this.msg['email'] = '';
      } else{
        this.msg['email'] = 'ที่อยู่อีเมลไม่ถูกต้อง';
      }
    },
    validateFirstName(value){
      if (value && value != null)
      {
        this.msg['first_name'] = '';
      } else{
        this.msg['first_name'] = 'โปรดระบุข้อมูล';
      }
    },
    validateLastName(value){
      if (value && value != null)
      {
        this.msg['last_name'] = '';
      } else{
        this.msg['last_name'] = 'โปรดระบุข้อมูล';
      }
    },
    validateDoctorID(value){
      const pattern = /^(?=.*[A-Za-z])(?=.*[0-9])(?=.{8,})/;
      if (pattern.test(value)){
        this.msg['staff_id'] = '';
      }else {
        this.msg['staff_id'] = 'เลข ว. ต้องประกอบด้วยตัวอักษร ตัวเลข อย่างน้อย 8 ตัว';
      }
    },
    // validatePassword(value){
    //     let difference = 8 - value.length;
    //     const pattern = /^(?=.*[A-Za-z])(?=.*[0-9])(?=.{8,})/;
    //     if (pattern.test(value)){
    //         this.msg['password'] = '';
    //     }else {
    //         this.msg['password'] = 'รหัสผ่านต้องประกอบด้วยตัวอักษร ตัวเลข อย่างน้อย 8 ตัว';
    //     }
    // },
    // validatePasswordconfirmation(value){
    //     if (this.password === value) {
    //         this.msg['password_confirmation'] = '' ;
    //     } else {
    //         this.msg['password_confirmation'] = 'รหัสไม่ถูกต้อง';
    //     }
    // },
    // (?=.*[A-Z])
    //     validateVIPPassword(value){
    //         const pattern = /^(?=.*[A-Za-z])(?=.*[0-9])(?=.{8,})/;
    //         if (pattern.test(value)){
    //             this.msg['vip_password'] = '';
    //         }else {
    //             this.msg['vip_password'] = 'รหัสผ่านต้องประกอบด้วยตัวอักษร ตัวเลข อย่างน้อย 8 ตัว';
    //         }
    //         // let difference = 8 - value.length;
    //         // if (value.length < 8) {
    //         //     this.msg['vip_password'] = 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร' ;
    //         // } else {
    //         //     this.msg['vip_password'] = '';
    //         //     if (pattern.test(value)){
    //         //         this.msg['vip_password'] = '';
    //         //     }else {
    //         //         this.msg['vip_password'] = 'ให้มีตัวเลขและตัวอักษร';
    //         //     }
    //         // }
    //     },
    //     validateVIPPasswordconfirmation(value){
    //         if (this.vip_password === value) {
    //             this.msg['vip_password_confirmation'] = '' ;
    //         } else {
    //             this.msg['vip_password_confirmation'] = 'รหัสไม่ถูกต้อง';
    //         }
    //     },
    validatePhonenumber(value){
      // let re = /^[0][0-9]{9}$/;
      if (value.length > 0 && value.length >= 9){
        // if (value.match(re)) {
        this.msg['phone_number'] = '';
        // }
      }else if (value.length == 0){
        this.msg['phone_number'] = '';
      }
      else {
        this.msg['phone_number'] = 'หมายเลขโทรศัพท์ไม่ถูกต้อง';
      }
    },
    checkLogin() {
      if (this.user_login == null) {
        this.$router.push({
          name: "LoginView"
        });
      } else if (this.user_login != null) {
        this.$router.push({
          name: "Status"
        });
      }
    },
    async checkValue() {
      if (this.valueHospital.hospcode == null ||
          this.usertype_id == null ||
          this.msg.first_name != '' ||
          this.msg.last_name != '' ||
          this.msg.phone_number != ''
      ) {
          // this.msg.staff_id != '' ||
        // alert(this.usertype_id)
        await this.showErrorFill('กรุณากรอกข้อมูลให้ถูกต้อง');
      } else {
        await this.requestPassword()
      }
    },
    async requestPassword() {
      let dataObj = {
        hospcode: String(this.valueHospital.hospcode).padStart(5, '0'),
        usertype_id: this.usertype_id,
        email: this.email.trim(),
        first_name:this.first_name,
        last_name:this.last_name,
        staff_id:this.staff_id,
        phone_number: this.phone_number,
        detailUser: this.detailUser,
        topic:"Forget Password"

        // password: this.password,
        // password_confirmation: this.password_confirmation,
        // vip_password_confirmation: this.vip_password_confirmation,
        // vip_password: this.vip_password,
      };
      this.$swal.showLoading()
      await this.$store.dispatch("Auth/request", dataObj).then((data) => {
        if (data){
          console.log(1)
          this.$swal.clickConfirm();
          this.showFill('ส่งคำขอคสำเร็จ');
        }

        // this.goToLoginPage();
        // this.goToHomePage()
      }).catch(e => {
        console.log(e)
        this.showErrorFill('ข้อมูลไม่ถูกต้อง');
      });

    },
    // login() {
    //   let data = {
    //     hospcode: this.hospcodes,
    //     password: this.passwords,
    //   };
    //   this.$store.dispatch("Auth/login", data)
    //       .then(() => {
    //         // if(!this.validPhoneNumber(this.phone_number)) {
    //         //     this.showErrorFill('กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง เช่น 0102345678');
    //         // } else {
    //         this.goToHomePage();
    //         // }
    //       }).catch(() => {
    //     this.showErrorFill('ข้อมูลไม่ถูกต้อง');
    //   });
    //   // this.goToHomePage();
    // },
    goToHomePage() {
      console.log("go to home page")
      const path = `/`
      if (this.$route.path !== path) this.$router.push(path)
    },
    goToLoginPage() {
      const path = `/`
      if (this.$route.path !== path) this.$router.push(path)
    },

    validPass: function (password) {
      var pass = /^Sadncd\d+$/;
      if (password.match(pass)) {
        return true;
      } else {
        return false;
      }
    },
    validPhoneNumber: function (phone_number) {
      var re = /^[0][0-9]{9}$/;
      if (phone_number.match(re)) {
        return true;
      } else {
        return false;
      }
    },
    getDistricts(province) {
      if (province) {
        this.login_form.district_id = "";
        this.$store.dispatch('Common/setDistrict', province.code);
      }
    },
    showErrorFill(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
      });
      Toast.fire({
        icon: 'error',
        title: message
      })
    },
    showFill(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
      });
      Toast.fire({
        icon: '',
        title: message
      })
    },
  }
}
</script>

<style scoped>
.multiselect__tags{
  background-color: #F2F2F2;
}
.login-form {
  color: white;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 24px;
  padding: 1.5em;
}

.regis-form {
  padding: 1.5em;
  height: 45vh;
}

.forget-pass {
  color: white !important;
  text-decoration: none;
  background-color: transparent;
}
select {
  text-align: center;
  text-align-last: center;
  /* webkit*/
}
option {
  text-align: left;
  /* reset to left*/
}


.text-center {
  margin: 0 auto;
  padding-top: 1em;
}

/*.btn-login {*/
/*    background: #EFEFEF;*/
/*    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);*/
/*    border-radius: 30px;*/
/*    font-weight: bolder;*/
/*    padding: 0.5em;*/
/*}*/
.btn-register {
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border: 3px solid #2DA1A9;
  border-radius: 30px;
  padding: 0.5em 2.25em;
}
.btn-login  {
  background: #2DA1A9;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border: 3px solid #2DA1A9;
  border-radius: 30px;
  padding: 0.5em 2.25em;
  color: #ffffff;
}
/*.btn-login {*/
/*    background: #2DA1A9;*/
/*    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);*/
/*    border-radius: 30px;*/
/*    font-weight: bolder;*/
/*    padding: 0.5em;*/
/*    margin-top: 1em;*/
/*}*/
/*.btn-register {*/
/*    background: #EFEFEF;*/
/*    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);*/
/*    border-radius: 30px;*/
/*    font-weight: bolder;*/
/*    padding: 0.5em;*/
/*    margin-top: 1em;*/
/*}*/



.custom-input-regis {
  height: calc(1.5em + 0.75rem + 2px);
  border: 1px;
  background: #F2F2F2;
  border-radius: 30px;
  margin-top: 0.75em;
  text-align: center;
  width: 80%;
  font-size: 14px;
}

.custom-input-regis::placeholder {
  color: #2DA1A9;
  text-align: center;
}

@media only screen and (max-width: 499px) {
  .custom-input {
    background: #FFFFFF;
    border-radius: 30px;
    margin-top: 1em;
    text-align: center;
    font-size: 14px;
    width: 80%;
  }

  .custom-input::placeholder {
    color: #9E9E9E;
    text-align: center;
  }
}
</style>

<!--<template>-->
<!--    <div class="container pr-3 pl-3 margin-3">-->
<!--        <div class="mb-5 pr-3 pl-3" style="margin-top: 5%">-->
<!--            <div class=" col-12 logo-side text-center text-head">-->
<!--                <img class=" mt-md-3 logo-size"-->
<!--                     src="../assets/logo-login.png">-->
<!--               ลงทะเบียนสำหรับเข้าสู่ระบบ-->
<!--            </div>-->
<!--            <div class="mt-4 offset-sm-2 col-sm-8 offset-1 col-10">-->
<!--                <div class="pt-4 mt-0 register-form">-->
<!--                    <div class="row">-->
<!--                            <div class="offset-md-2 offset-1 col-md-8 col-10">-->
<!--                                <div class="form-group">-->
<!--                                    <label>ชื่อจริง</label>-->
<!--                                    <input v-model="form.first_name"-->
<!--                                           type="text" class="form-control"  >-->
<!--                                </div>-->
<!--                                <div class="form-group">-->
<!--                                    <label >นามสกุล</label>-->
<!--                                    <input  v-model="form.last_name"-->
<!--                                            type="text" class="form-control" >-->
<!--                                </div>-->
<!--                                <div class="form-group">-->
<!--                                    <label >เลขประจำตัวประชาชน</label>-->
<!--                                    <input  v-model="form.username"-->
<!--                                            type="text" class="form-control" maxlength="13">-->
<!--                                </div>-->
<!--                                <div class="form-group">-->
<!--                                    <label >เบอร์โทรศัพท์</label>-->
<!--                                    <input  v-model="form.phone_number"-->
<!--                                            type="number" class="form-control" maxlength="10" >-->
<!--                                </div>-->
<!--                                <div class="form-group">-->
<!--                                    <label >เลือกระดับผู้ใช้</label>-->

<!--                                    <select v-model="form.user_type_id"-->
<!--                                            class="browser-default custom-select">-->
<!--                                        <option value="" disabled hidden>ระดับผู้ใช้</option>-->
<!--                                        <option value="1">ระดับเขต</option>-->
<!--                                        <option value="2">ระดับจังหวัด</option>-->
<!--                                        <option value="3">ระดับอำเภอ</option>-->
<!--                                    </select>-->

<!--                                </div>-->
<!--                                <template v-if="form.user_type_id == 1">-->
<!--                                    <div class="form-group">-->
<!--                                        <label >ระดับเขต</label>-->
<!--                                        <select v-model="form.area_id"-->
<!--                                                class="browser-default custom-select">-->
<!--                                            <option value="" disabled hidden>ระดับเขต</option>-->
<!--                                            <option value="1">เขต 1</option>-->
<!--                                            <option value="2">เขต 2</option>-->
<!--                                            <option value="3">เขต 3</option>-->
<!--                                            <option value="4">เขต 4</option>-->
<!--                                            <option value="5">เขต 5</option>-->
<!--                                            <option value="6">เขต 6</option>-->
<!--                                            <option value="7">เขต 7</option>-->
<!--                                            <option value="8">เขต 8</option>-->
<!--                                            <option value="9">เขต 9</option>-->
<!--                                            <option value="10">เขต 10</option>-->
<!--                                            <option value="11">เขต 11</option>-->
<!--                                            <option value="12">เขต 12</option>-->
<!--                                            <option value="13">สปคม</option>-->
<!--                                        </select>-->
<!--                                    </div>-->
<!--                                </template>-->
<!--                                <template v-if="form.user_type_id == 2">-->
<!--                                    <div class="form-group">-->
<!--                                        <label >จังหวัด</label>-->

<!--                                        <multiselect-->
<!--                                                v-model="form.province"-->
<!--                                                :options="optionProvince"-->
<!--                                                label="name"-->
<!--                                                select-label=""-->
<!--                                                selectedLabel=""-->
<!--                                                deselect-label=""-->
<!--                                                placeholder="เลือกจังหวัด"-->
<!--                                                track-by="name">-->
<!--                                        </multiselect>-->
<!--                                    </div>-->
<!--                                </template>-->
<!--                                <template v-if="form.user_type_id == 3">-->
<!--                                    <div class="form-group">-->
<!--                                        <div class="row">-->
<!--                                            <div class="col-md-6 col-12">-->
<!--                                                <label >จังหวัด</label>-->
<!--                                                <multiselect-->
<!--                                                        v-model="form.province"-->
<!--                                                        @input="getDistricts(form.province)"-->
<!--                                                        :options="optionProvince"-->
<!--                                                        label="name"-->
<!--                                                        select-label=""-->
<!--                                                        selectedLabel=""-->
<!--                                                        deselect-label=""-->
<!--                                                        placeholder="เลือกจังหวัด"-->
<!--                                                        track-by="name">-->
<!--                                                </multiselect>-->
<!--                                            </div>-->
<!--                                            <div class="col-md-6 col-12">-->
<!--                                                <label >อำเภอ</label>-->
<!--                                                <multiselect-->
<!--                                                        v-model="form.district"-->
<!--                                                        :options="optionDistrict"-->
<!--                                                        label="name"-->
<!--                                                        select-label=""-->
<!--                                                        selectedLabel=""-->
<!--                                                        deselect-label=""-->
<!--                                                        placeholder="เลือกอำเภอ"-->
<!--                                                        track-by="name"-->
<!--                                                        :allow-empty="false" >-->
<!--                                                </multiselect>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </template>-->

<!--                                <div class="mt-4 form-group">-->

<!--                                    <label  for="file-upload" class="custom-file-upload">-->
<!--                                        <i class="fas fa-plus"></i> อัพโหลดรูปข้าราชการ/ประชาชน-->
<!--                                    </label>-->
<!--                                    <input  @change="imageFileUpload"-->
<!--                                             id="file-upload" type="file"/>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                </div>-->

<!--                <div class="pt-4 pb-3 text-center" >-->
<!--                    <b-button @click="saveUser"-->
<!--                              type="submit" variant="dark" class="btn-submit">-->
<!--                        บันทึก-->
<!--                    </b-button>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</template>-->

<!--<script>-->
<!--    import { mapState } from "vuex";-->
<!--    import Multiselect from 'vue-multiselect';-->

<!--    export default {-->
<!--        name: "RegisterView",-->
<!--        props: {-->
<!--            id: { default: null }-->
<!--        },-->
<!--        components: {-->
<!--            Multiselect-->
<!--        },-->
<!--        created(){-->
<!--            //this.checkLogin();-->
<!--            this.$store.dispatch("Common/setProvince");-->
<!--            this.$store.dispatch("Auth/clearFormData");-->
<!--        },-->
<!--        computed: {-->
<!--            ...mapState({-->
<!--                form : state=>{-->
<!--                    return state.Auth.form;-->
<!--                },-->
<!--                optionProvince : state=>{-->
<!--                    return state.Common.provinces;-->
<!--                },-->
<!--                optionDistrict : state=>{-->
<!--                    return state.Common.districts;-->
<!--                },-->
<!--                user_login : state=>{-->
<!--                    return state.Auth.user_login-->
<!--                }-->
<!--            })-->
<!--        },-->
<!--        data() {-->
<!--            return {-->
<!--                optionsUserType: [-->
<!--                    {name: 'ส่วนกลาง', value: '1'},-->
<!--                    {name: 'ส่วนจังหวัด', value: '2'},-->
<!--                    {name: 'ส่วนอำเภอ', value: '3'},-->
<!--                ]-->
<!--            };-->
<!--        },-->
<!--        methods:{-->
<!--            checkLogin(){-->
<!--                if(this.user_login == null){-->
<!--                    this.$router.push({-->
<!--                        name:"RegisterView"-->
<!--                    });-->
<!--                }-->
<!--                else if(this.user_login != null){-->
<!--                    this.$router.push({-->
<!--                        name:"Status"-->
<!--                    });-->
<!--                }-->
<!--            },-->
<!--            getDistricts(province){-->
<!--                if(province){-->
<!--                    this.form.district = null;-->
<!--                    this.$store.dispatch('Common/setDistrict',province.code);-->
<!--                }-->
<!--            },-->
<!--            imageFileUpload:function (event) {-->
<!--                let input = event.target;-->
<!--                this.form.avatar = input.files[0];-->
<!--            },-->
<!--            saveUser(){-->
<!--                if(!this.form.first_name ){-->
<!--                    alert("กรุณากรอกชื่อจริง");-->
<!--                }-->
<!--                else if(!this.validName(this.form.first_name)){-->
<!--                    alert("กรุณากรอกชื่อจริงให้ถูกต้อง");-->
<!--                }-->
<!--                else if(!this.form.last_name ){-->
<!--                    alert("กรุณากรอกนามสกุล");-->
<!--                }-->
<!--                else if(!this.validName(this.form.last_name)){-->
<!--                    alert("กรุณากรอกนามสกุลให้ถูกต้อง");-->
<!--                }-->
<!--                else if(!this.form.username ){-->
<!--                    alert("กรุณากรอกเลขบัตรประจำตัวประชาชน");-->
<!--                }-->
<!--                else if(!this.validUsername(this.form.username)){-->
<!--                    alert("กรุณากรอกเลขบัตรประจำตัวประชาชนให้ถูกต้อง");-->
<!--                }-->
<!--                else if(!this.form.phone_number ){-->
<!--                    alert("กรุณากรอกเบอร์โทรศัพท์");-->
<!--                }-->
<!--                else if(!this.validPhoneNumber(this.form.phone_number)){-->
<!--                    alert("กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง เช่น 0102345678");-->
<!--                }-->
<!--                else if(!this.form.user_type_id ){-->
<!--                    alert("กรุณาเลือกระดับผู้ใช้");-->
<!--                }-->
<!--                else if(this.form.user_type_id == 1 && !this.form.area_id  ){-->
<!--                    alert("กรุณาเลือกเขตสุขภาพ");-->
<!--                }-->
<!--                else if((this.form.user_type_id == 2 || this.form.user_type_id == 3) && !this.form.province ){-->
<!--                    alert("กรุณาเลือกจังหวัด",);-->
<!--                }-->
<!--                else if(this.form.user_type_id == 3 && !this.form.district ){-->
<!--                    alert("กรุณาเลือกอำเภอ");-->
<!--                }-->
<!--                else{-->
<!--                    if(this.form.province){-->
<!--                        this.form.province_id = this.form.province.id;-->
<!--                    }-->
<!--                    if(this.form.district ){-->
<!--                        this.form.district_id = this.form.district.id;-->
<!--                    }-->

<!--                    if(!this.form.avatar){-->
<!--                        this.form.avatar = "";-->
<!--                    }-->
<!--                    let data = {-->
<!--                        first_name: this.form.first_name,-->
<!--                        last_name: this.form.last_name,-->
<!--                        username: this.form.username,-->
<!--                        phone_number: this.form.phone_number,-->
<!--                        user_type_id: this.form.user_type_id,-->
<!--                        area_id: this.form.area_id,-->
<!--                        province_id: this.form.province_id,-->
<!--                        district_id: this.form.district_id,-->
<!--                        avatar : this.form.avatar,-->
<!--                    };-->
<!--                    let formData = new FormData();-->
<!--                    formData.append('first_name',data.first_name);-->
<!--                    formData.append('last_name',data.last_name);-->
<!--                    formData.append('username',data.username);-->
<!--                    formData.append('phone_number',data.phone_number);-->
<!--                    formData.append('user_type_id',data.user_type_id);-->
<!--                    formData.append('area_id',data.area_id);-->
<!--                    formData.append('province_id',data.province_id);-->
<!--                    formData.append('district_id',data.district_id);-->
<!--                    formData.append('avatar',data.avatar);-->
<!--                    if(this.id){-->
<!--                        formData.append("_method",'put');-->
<!--                    }-->
<!--                    this.$store.dispatch("Auth/register",formData)-->
<!--                    this.goToLogin();-->
<!--                }-->
<!--            },-->
<!--            goToLogin(){-->
<!--              this.$swal('สมัครเรียบร้อย <br>' +-->
<!--                'username:' + this.form.username + ' <br>'+-->
<!--                'password:' + this.form.phone_number );-->
<!--                this.$router.push({-->
<!--                    name:"LoginView"-->
<!--                });-->
<!--            },-->
<!--            validName: function (name) {-->
<!--                var re = /[^0-9]$/;-->
<!--                if(name.match(re)){-->
<!--                    return true;-->
<!--                }-->
<!--                else{-->
<!--                    return false;-->
<!--                }-->
<!--            },-->
<!--            validUsername: function (username) {-->
<!--                var re = /[0-9]{13}$/;-->
<!--                if(username.match(re)){-->
<!--                   return true;-->
<!--                }-->
<!--                else{-->
<!--                    return false;-->
<!--                }-->
<!--            },-->
<!--            validPhoneNumber: function (phone_number) {-->
<!--                var re = /^[0][0-9]{9}$/;-->
<!--                if(phone_number.match(re)){-->
<!--                    return true;-->
<!--                }-->
<!--                else{-->
<!--                    return false;-->
<!--                }-->
<!--            }-->
<!--        }-->
<!--    }-->
<!--</script>-->

<!--<style scoped>-->
<!--    input[type="file"] {-->
<!--        display: none;-->
<!--    }-->
<!--    .custom-file-upload {-->
<!--        background-color: #E5E5E5;-->
<!--        color: #006738;-->
<!--        border: 2px solid gray;-->
<!--        padding: 10px 10px 3px 10px;-->
<!--        border-radius: 7px;-->
<!--        font-size: 24px;-->
<!--        font-weight: bold;-->
<!--        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);-->
<!--        display: inline-block;-->
<!--        cursor: pointer;-->
<!--    }-->

<!--    .register-form{-->
<!--        background-color: #006738;-->
<!--        color: white;-->
<!--        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);-->
<!--        border-radius: 24px;-->
<!--        font-size: 24px;-->
<!--        font-weight: 700;-->
<!--        letter-spacing: 2px;-->
<!--    }-->
<!--    .logo-size{-->
<!--        height: 110px;-->
<!--    }-->

<!--    .text-head{-->
<!--        color: #006738;-->
<!--        font-size: 38px;-->
<!--    }-->

<!--    .register-form input{-->
<!--        font-size: 22px;-->
<!--        font-weight: 400;-->
<!--    }-->
<!--    .register-form select{-->
<!--        font-size: 22px;-->
<!--        font-weight: 400;-->
<!--    }-->

<!--    .btn-submit{-->
<!--        background-color: #006738;-->
<!--        color: white;-->
<!--        font-size: 25px;-->
<!--        font-weight: 700;-->
<!--        padding: 7px 25px 3px 25px;-->
<!--    }-->

<!--    .upload-btn-wrapper {-->
<!--        position: relative;-->
<!--        overflow: hidden;-->
<!--        display: inline-block;-->
<!--    }-->

<!--    .btn-upload {-->
<!--        background-color: #E5E5E5;-->
<!--        color: #006738;-->
<!--        border: 2px solid gray;-->
<!--        padding: 10px 10px 3px 10px;-->
<!--        border-radius: 7px;-->
<!--        font-size: 24px;-->
<!--        font-weight: bold;-->
<!--        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);-->
<!--    }-->

<!--    .upload-btn-wrapper input[type=file] {-->
<!--        font-size: 100px;-->
<!--        position: absolute;-->
<!--        left: 0;-->
<!--        top: 0;-->
<!--        opacity: 0;-->
<!--    }-->
<!--    @media only screen and (max-width: 767px) {-->
<!--        .logo-size{-->
<!--            height: 90px;-->
<!--        }-->

<!--        .text-head{-->
<!--            font-size: 30px;-->
<!--        }-->

<!--    }-->

<!--    @media only screen and (max-width: 499px) {-->
<!--        .logo-size{-->
<!--            height: 70px;-->
<!--        }-->

<!--        .text-head{-->
<!--            font-size: 23px;-->
<!--        }-->

<!--        .btn-submit{-->
<!--            font-size: 17px;-->
<!--        }-->

<!--        .register-form{-->
<!--            font-size: 18px;-->
<!--        }-->

<!--        .register-form input {-->
<!--            font-size: 18px;-->
<!--        }-->
<!--        .register-form select{-->
<!--            font-size: 18px;-->
<!--        }-->

<!--        .custom-file-upload {-->
<!--            font-size: 16px;-->
<!--        }-->

<!--        .multiselect{-->
<!--            font-size: 18px !important;-->
<!--        }-->
<!--        .multiselect__input{-->
<!--            font-size: 18px !important;-->
<!--        }-->
<!--        .multiselect__single {-->
<!--            font-size: 18px !important;-->
<!--        }-->
<!--    }-->
<!--    @media only screen and (max-width: 350px) {-->

<!--        .text-head{-->
<!--            font-size: 20px;-->
<!--            text-align: center;-->
<!--        }-->

<!--    }-->


<!--</style>-->
